"use strict";

import { isArray } from "lodash";

export function generateCellContent(headerKey, headerObj, data) {
  let val = "";
  if (headerKey.indexOf("+") > 0) {
    headerKey.split("+").forEach((k, i) => {
      // deal with compound key
      if (data[k] && data[k] !== "null") val += (i === 0 || val === "" ? "" : " - ") + data[k]; // ignore null
    });
  } else if (headerKey.indexOf(".") > 0) {
    // deal with embedded data object
    headerKey.split(".").forEach((k, i) => {
      if (i === 0) {
        val = data && data[k] ? data[k] : "";
      } else {
        val = val && val[k] ? val[k] : "";
      }
    });
  } else {
    val = data[headerKey];
  }
  if (headerObj.converter) {
    val = headerObj.converter(val, data, headerKey);
  }
  if (isArray(val) && val.length === 0) val.push("N/A");
  return val || "N/A";
}

export function sorterStringGen(key) {
  return (a, b) => (a[key] || "").localeCompare(b[key] || "");
}

export function sorterNumberGen(key) {
  return (a, b) => (a[key] || 0) - (b[key] || 0);
}

export function diversifyHighlight(fields) {
  // a factory function to diversify highlights across specified fields from a multi-field full-text search
  return record => {
    const counts = fields.map(field => record["highlight"][field] ? record["highlight"][field].length : 0);
    let highlightsWithTag = [];
    // when count total is less than or equal to the number of fields, simply show all highlights
    if (counts.reduce((a, b) => a + b, 0) <= fields.length) {
      fields.forEach(field => {
        if (record["highlight"][field]) {
          record["highlight"][field].forEach(hl => {
            highlightsWithTag.push({ field, highlight: hl });
          });
        }
      });
      return highlightsWithTag;
    }
    // if not, sample highlights from each field to make sure all fields are represented
    let sampleCnt = [0, 0, 0, 0, 0];
    while (sampleCnt.reduce((a, b) => a + b, 0) < fields.length) {
      for (var i = 0; i < fields.length; i++) {
        const field = fields[i];
        if (record["highlight"][field] && sampleCnt[i] < record["highlight"][field].length) {
          sampleCnt[i] = sampleCnt[i] + 1;
          if (sampleCnt.reduce((a, b) => a + b, 0) == 5) {
            break;
          }
        }
      }
    }
    for (i = 0; i < sampleCnt.length; i++) {
      if (sampleCnt[i] == 0) {
        continue;
      }
      const field = fields[i];
      for (var j = 0; j < sampleCnt[i]; j++) {
        highlightsWithTag.push({ field, highlight: record["highlight"][field][j] });
      }
    }
    return highlightsWithTag;
  };
}